import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllSkills: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	skillsSectionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spacesSectionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	floatingMenuLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'ai-mate.auto-suggest-skills-browse.title',
		defaultMessage: 'Suggested skills',
		description: 'Title above the suggested skills list in auto-suggest',
	},
	viewAllSkills: {
		id: 'ai-mate.auto-suggest-skills-browse.view-all-skills',
		defaultMessage: 'View all skills',
		description: 'Label for the last row that opens the full skills browse (shortcut ⌘9)',
	},
	skillsSectionTitle: {
		id: 'ai-mate.auto-suggest-floating-menu.skills-section-title',
		defaultMessage: 'Skills',
		description: 'Section heading above the skills list in the floating-menu auto-suggest',
	},
	spacesSectionTitle: {
		id: 'ai-mate.auto-suggest-floating-menu.spaces-section-title',
		defaultMessage: 'Go to space',
		description: 'Section heading above the spaces list in the floating-menu auto-suggest',
	},
	floatingMenuLabel: {
		id: 'ai-mate.auto-suggest-floating-menu.listbox-label',
		defaultMessage: 'Suggestions',
		description: 'Accessible label for the auto-suggest floating menu listbox',
	},
});
